 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~36db4727":"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~36db4727","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~25797984":"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~25797984","default~mappa-mappa-module-ngfactory~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~e19e6073":"default~mappa-mappa-module-ngfactory~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~e19e6073","default~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~task-task-module-ngfactory~u~121a204e":"default~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~task-task-module-ngfactory~u~121a204e","default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory~panoramica-cantiere-panoramica-cantiere-mo~43fc270d":"default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory~panoramica-cantiere-panoramica-cantiere-mo~43fc270d","default~login-login-module-ngfactory~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panora~6a2f8e59":"default~login-login-module-ngfactory~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panora~6a2f8e59","default~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panoramica-panoramica-module-ngfact~b2352440":"default~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panoramica-panoramica-module-ngfact~b2352440","common":"common","panoramica-panoramica-module-ngfactory":"panoramica-panoramica-module-ngfactory","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~3ff02b9d":"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~3ff02b9d","menu-menu-module-ngfactory":"menu-menu-module-ngfactory","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~07328a9a":"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~07328a9a","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~4007d525":"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~4007d525","commessa-commessa-module-ngfactory":"commessa-commessa-module-ngfactory","rfid-rfid-module-ngfactory":"rfid-rfid-module-ngfactory","tipo-dispositivo-tipo-dispositivo-module-ngfactory":"tipo-dispositivo-tipo-dispositivo-module-ngfactory","tipo-rfid-tipo-rfid-module-ngfactory":"tipo-rfid-tipo-rfid-module-ngfactory","default~cantiere-cantiere-module-ngfactory~mappa-mappa-module-ngfactory~panoramica-cantiere-panorami~3804f59a":"default~cantiere-cantiere-module-ngfactory~mappa-mappa-module-ngfactory~panoramica-cantiere-panorami~3804f59a","cantiere-cantiere-module-ngfactory":"cantiere-cantiere-module-ngfactory","panoramica-cantiere-panoramica-cantiere-module-ngfactory":"panoramica-cantiere-panoramica-cantiere-module-ngfactory","default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory":"default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory","dpc-dpc-module-ngfactory":"dpc-dpc-module-ngfactory","dpi-dpi-module-ngfactory":"dpi-dpi-module-ngfactory","mappa-mappa-module-ngfactory":"mappa-mappa-module-ngfactory","utente-utente-module-ngfactory":"utente-utente-module-ngfactory","default~odl-odl-module-ngfactory~utente-dpi-utente-dpi-module-ngfactory":"default~odl-odl-module-ngfactory~utente-dpi-utente-dpi-module-ngfactory","default~odl-odl-module-ngfactory~task-task-module-ngfactory":"default~odl-odl-module-ngfactory~task-task-module-ngfactory","odl-odl-module-ngfactory":"odl-odl-module-ngfactory","task-task-module-ngfactory":"task-task-module-ngfactory","utente-dpi-utente-dpi-module-ngfactory":"utente-dpi-utente-dpi-module-ngfactory","login-login-module-ngfactory":"login-login-module-ngfactory"}[chunkId]||chunkId) + "." + {"default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~36db4727":"2369e00d521761fa173e","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~25797984":"794a31ae0031b6734ef7","default~mappa-mappa-module-ngfactory~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~e19e6073":"3dd5b4c999ea53c41a93","default~odl-odl-module-ngfactory~panoramica-panoramica-module-ngfactory~task-task-module-ngfactory~u~121a204e":"7c9972c8d9bf33600966","default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory~panoramica-cantiere-panoramica-cantiere-mo~43fc270d":"41597536c60100ad6e49","default~login-login-module-ngfactory~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panora~6a2f8e59":"f0b5a6fa30bc7dde98ac","default~panoramica-cantiere-panoramica-cantiere-module-ngfactory~panoramica-panoramica-module-ngfact~b2352440":"0f354621fedc89b7216e","common":"6398384349aaf800d4c7","panoramica-panoramica-module-ngfactory":"8437f4eda992c1b6f400","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~3ff02b9d":"849a347a6f62c393ad4c","menu-menu-module-ngfactory":"4420b9a1606da646e025","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~07328a9a":"4352d9116bc594588d5c","default~cantiere-cantiere-module-ngfactory~commessa-commessa-module-ngfactory~dpc-dpc-module-ngfacto~4007d525":"71536bf3bcb0882e8d0d","commessa-commessa-module-ngfactory":"fb0e46c3cf7cd8e6ff0d","rfid-rfid-module-ngfactory":"8cfd79d0900b89678e4d","tipo-dispositivo-tipo-dispositivo-module-ngfactory":"d1ad9fc4b9d431f21173","tipo-rfid-tipo-rfid-module-ngfactory":"002b75af9f9b2b15c3a4","default~cantiere-cantiere-module-ngfactory~mappa-mappa-module-ngfactory~panoramica-cantiere-panorami~3804f59a":"1e09b134f62d5fdbdc25","cantiere-cantiere-module-ngfactory":"e8f158db60bd1c330ea6","panoramica-cantiere-panoramica-cantiere-module-ngfactory":"37a69d9547d32996337b","default~dpc-dpc-module-ngfactory~dpi-dpi-module-ngfactory":"dd2969b9044c2284ff30","dpc-dpc-module-ngfactory":"39bbf259399ddff34a41","dpi-dpi-module-ngfactory":"1fb1f648603dec285afe","mappa-mappa-module-ngfactory":"3b1ce73b643d5202d98b","utente-utente-module-ngfactory":"6fcb276c57f8bb913d7a","default~odl-odl-module-ngfactory~utente-dpi-utente-dpi-module-ngfactory":"e61f43d67e03f9cc5440","default~odl-odl-module-ngfactory~task-task-module-ngfactory":"d896dd071087c952c41f","odl-odl-module-ngfactory":"a2057bee426326f8393f","task-task-module-ngfactory":"bf3b50dba8823a534733","utente-dpi-utente-dpi-module-ngfactory":"08bc6cb24bb5ac78f819","login-login-module-ngfactory":"033fe64871df08762f32"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
